import BaseValidator from '../internals/validation';
export default class OrderValidator extends BaseValidator {
    constructor(order) {
        super();
        this._order = order;
    }
}
//# sourceMappingURL=validation.js.map